import { fetch_sadap } from "../../core/api"

export function getMessageByRoom(roomId) {
    const path = `chat/messages/${roomId}`
    return fetch_sadap(path, "get", {}, false)
}

export function uploadFileMessage(file) {
    const path = `chat/attachment`
    return fetch_sadap(path, "post", file, true)
}